/**
 * Compact field label matching prototype `.req-modal-field-l`.
 */
function FieldLabel({ htmlFor, required = false, children }) {
  return (
    <label
      htmlFor={htmlFor}
      className="flex items-center gap-[5px] text-[11px] font-semibold text-content-secondary"
    >
      {children}
      {required ? (
        <span className="font-bold text-[#ff7d7d] dark:text-[#ff7d7d]" aria-hidden="true">
          *
        </span>
      ) : null}
    </label>
  );
}

export default FieldLabel;
